export default __webpack_public_path__ + "static/media/messengerLight.e5293328.svg";